import { EvaluacionProductividadAdapter } from '../adapters/EvaluacionProductividad.adapter'

export default class GetEvaluacionProductividadUseCase {
  #repository

  constructor(repository) {
    this.#repository = repository
  }

  async execute({ idPersonal, idEvaluacion }) {
    try {
      const dto = await this.#repository.getById(idPersonal, idEvaluacion)
      return EvaluacionProductividadAdapter.toEntity(dto)
    } catch (error) {
      throw new Error(`Failed to execute GetEvaluacionProductividadUseCase: ${error.message}`)
    }
  }
}
